// reducers/libraryReducer.js
export const libraryReducer = (state = { books: [] }, action) => {
  switch (action.type) {
    case "LIBRARY_REQUEST":
      return { ...state, loading: true };
    case "GET_BOOKS_SUCCESS":
      return { loading: false, books: action.payload };
    case "ISSUE_BOOK_SUCCESS":
      return { loading: false, success: true };
    case "RETURN_BOOK_SUCCESS":
      return { loading: false, returned: true };
    case "GET_MY_BOOKS_SUCCESS":
      return { loading: false, myBooks: action.payload };
    case "LIBRARY_FAIL":
      return { loading: false, error: action.payload };
    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false, returned: false };
    default:
      return state;
  }
};
